import request from "@/utils/request";

export function getRoomType(params) {
  return request({
    url: "/BookingApplication/RoomType",
    method: "get",
    params
  });
}
export function getPageList(data) {
  return request({
    url: "/BookingApplication/RoomView",
    method: "get",
    params: data
  });
}
export function submit(data) {
  return request({
    url: "/BookingApplication/Submit",
    method: "post",
    data
  });
}
export function getRoomQuota(data) {
  return request({
    url: "/BookingApplication/ValidateRoomAmount",
    method: "post",
    data
  });
}
